import { Box } from '@mui/material';
import React from 'react';
import { ISuggestionContainer, SuggestionContainer } from './SuggestionContainer';

export interface IRightFeedLayer extends ISuggestionContainer {}
export const RightFeedLayer: React.FC<IRightFeedLayer> = props => {
    return (
        <Box>
            <SuggestionContainer {...props} />
        </Box>
    );
};
